import {FormError} from './FormError.js'

export class CaptchaStatusNotFoundFormError extends FormError {}
